import { createStyles } from "@material-ui/core";

export type HomeClassKey = "input";

export const HomeStyleRules = createStyles({
  input: {}
});
